<template>
  <div>
    <section v-if="product" class="product-detail">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 align-self-center" data-aos="fade-in">
            <template v-if="product.images.length > 0">
              <div class="zoom-container">
                <image-zoom :regular="product.images[0].url" :zoom="product.images[0].url" :zoom-amount="2" :click-zoom="true" alt="Image: Product Image"></image-zoom>
              </div>
            </template>
          </div>
          <div class="col-12 col-md-6">
            <div class="content" data-aos="fade-in">
              <h1 class="smaller">{{ product.title }}
                <span v-bind:class="['favourite', {
                   'active' : $root.isProductInBasket(product.id)
                  }]" v-on:click="toggleProductInBasket($event, product.id)"
                      title="Add or remove from favourites"></span>
              </h1>
              <!--<p class="larger">{{ product.description }}</p>-->
              <div v-for="(content, index) in product.content" :key="index" class="notes">
                <h4>{{ content.name }}</h4>
                <div v-html="content.value"></div>
              </div>

              <h4>Product Details</h4>
              <div class="list">
                <dl v-for="(option, index) in product.category_options" :key="index">
                  <dt>{{ option.category ? option.category.title : 'Unknown' }}</dt>
                  <dd>{{ option.name }}</dd>
                </dl>
              </div>


              <template v-if="product.images.length > 0 || product.files.length > 0">
                <h4>Related Media</h4>
                <div class="files">
                  <ul>
                    <li>
                      <router-link :to="{ name: 'product-spec', params: { slug: product.slug }}"
                                   :title="'Link: ' + product.title + ' Spec Sheet'" class="btn btn-sm btn-outline-dark"
                                   target="_blank">
                        Spec Sheet
                      </router-link>
                    </li>
                    <li>
                      <a class="btn btn-sm btn-outline-dark" v-if="product.images.length > 0" :href="product.images[0].url + '?response-content-disposition=attachment;'" :title="'Product Image: ' + product.title">
                        Product Image
                      </a>
                    </li>
                    <li v-for="(file, index) in product.files" :key="index" class="notes">
                      <a class="btn btn-sm btn-outline-dark" :href="file.url + '?response-content-disposition=attachment;'">
                        {{ file.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </template>

              <p class="lead">Find this Vintriguing? get in touch for more info</p>

              <a v-bind:href="'mailto:' + this.$root.store.contact_email + '?subject=I find this product Vintriguing, let me know more&body=' + this.messageBody()" class="btn btn-dark mr-1">Email our team</a>
              <a v-bind:href="'tel:' + this.$root.store.telephone_number" class="btn btn-outline-dark">Give us a
                call</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import imageZoom from 'vue-image-zoomer'

  export default {
    name: 'ProductDetail',
    components: {
      imageZoom
    },
    props: {
      product: {
        type: Object,
        default: null
      },
    },
    methods: {
      toggleProductInBasket($event, productId) {
        if (this.$root.isProductInBasket(productId)) {
          this.$root.removeProductFromBasket(productId)
        } else {
          this.$root.addProductToBasket(productId)
        }
      },
      messageBody: function () {
        let message = '';
        if (this.product) {
          message += 'Title: ' + encodeURIComponent(this.product.title) + '%0D%0A';
          message += 'Code: ' + this.product.code;
        }
        return message;
      }
    }
  }
</script>
